module.exports = __webpack_public_path__ + "img/logo.b4f7f763.png";